import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export const Loader: React.FC<{ isLoading: boolean; onClose?: () => void }> = ({ isLoading, onClose, children }) => {
	return (
		<Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={isLoading} onClick={onClose}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					'& > *:not(:last-child)': {
						marginBottom: 1.5
					}
				}}
			>
				<CircularProgress color='inherit' />
				{children}
			</Box>
		</Backdrop>
	);
};
